import _get from 'lodash/get';

export const getCloseReason = () => _get(window, 'firebolt_closeReason', '');

export const setCloseReason = reason => {
  window.firebolt_closeReason = reason;
};
